import { type MouseEvent } from 'react';

import { navigateToUrl } from '@/modules/routing/helpers';

// Longest delay the user's navigation waits for an AT event to send
export const NAVIGATE_AFTER_TRACKING_TIMEOUT_MS = 500;

export function navigateAfterTracking(
  event: MouseEvent<HTMLAnchorElement>,
  tracking: Promise<unknown>
) {
  // Read from the rendered <a>
  const { href, target } = event.currentTarget;

  // Let the browser handle anything that keeps this page open (e.g. new tab/window
  // or non-left click), as the tracking API request will finish on its own
  if (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey ||
    (target && target !== '_self')
  ) {
    return;
  }

  // Stop the browser navigating to the next page
  event.preventDefault();

  function navigate() {
    navigateToUrl(href);
  }

  // Navigate as soon as tracking settles or the timeout fires, whichever is
  // first
  Promise.race([
    tracking,
    new Promise((resolve) =>
      setTimeout(resolve, NAVIGATE_AFTER_TRACKING_TIMEOUT_MS)
    ),
  ]).then(navigate, navigate);
}
